<script>
export default {
    name: "Stocklevelperstore",

    data() {

        return {
            itemsstocks: [],
            items: [],
            qtyitems: [],
            stores:[],
            filter: {
                date: window.moment().format('YYYY-MM-DD'),
                storeId:0,
                searchFilter:'',

            },
            userName: this.$root.username,
        };
    },

    mounted () {

      //  this.fetchAll();
        this. getStores();
        
    },

    methods: {

        fetchAll () {

            this.$root.loading = true;
            let url=`Inventory/GetItemsStockLevelperStore?StoreId=${this.filter.storeId}`;
              url += this.filter.searchFilter ? `&SearchText=${this.filter.searchFilter}` : ``;
              
           this.$accountsHttp.get(url)
                .then(response => { this.itemsstocks = response.data; this.$root.loading = false; })
                .catch(() => { this.$root.loading = false; });
        },
        getItemStockLevel(ItemId,StoreId) {
 
let qtystoreitems=this.itemsstocks.itemsStore.filter(itm => itm.itemID == ItemId && itm.storeID == StoreId);
 qtystoreitems.length
                                        ?
                                       qtystoreitems[0].qty
                                        :
                                        0
 
    },
      getStores() {
            return this.$accountsHttp.get('Shared/Stores').then(response => {
                this.stores = response.data;
            }).catch(() => {});
        },
},
}
</script>
<template>
    <tail-base-layout>
        <template v-slot:content>
            <tail-card>
                <template v-slot:card-header>
                    <h5 class="text-sm font-medium">Stock Level Per Store Report</h5>
                </template>
                <template v-slot:card-body>
                    <div class="flex w-full">
                        <div class="w-1/4 p-tiny">
                        <input type="text" v-model.trim="filter.searchFilter"
                     
                    id="grid-search" class="input-control input-sm text-xs">   </div>
                       
                        <div class="p-tiny">
                     <label for="grid-store-from" class="label-control">Store:</label>
                   </div> <div class="w-1/4 p-tiny">
                <tail-select>
                    <template v-slot:field>
                        <select id="grid-store-from" 
                              v-model.trim="filter.storeId"
                            class="input-control input-sm text-xs">
                            <option :value="0">Select store</option>
                            <option v-for="store in stores" 
                                :key="store.id" :value="store.id">{{ store.name }}</option>
                        </select>
                    </template>
                </tail-select>
               
            </div> <div class="w-1/4 p-tiny pl-2">
                            <button class="btn-sm btn-info text-xs rounded" @click.prevent="fetchAll"><i class="fa fa-filter"></i> Filter</button>
                        </div>
                    </div>
                    <div class="w-full overflow-auto">
                        <table class="table table-hover">
                            <thead class="bg-blue-500 text-xs text-white">
                                <tr class="w-full flex">
                                    <th class="p-tiny w-1/6">ItemId</th>
                                    <th class="p-tiny w-1/6">ItemName</th>
                                    <th  v-for="(store, idx) in itemsstocks.stores" :key="idx"
                                        class="p-tiny flex-1">{{store.store }}</th>
                                     </tr>
                            </thead>
                            <tbody class="flex flex-col items-center text-xs bg-gray-100 overflow-auto" style="height:70vh;">
                                <tr class="flex w-full" v-for="(item, idx) in itemsstocks.items" :key="idx">
                                    <td class="p-tiny w-1/6">{{item.itemID }}</td>
                                    <td class="p-tiny w-1/6">{{ item.itemName}}</td>
                                    <td class="p-tiny flex-1" v-for="(store, idxc) in itemsstocks.stores" :key="idxc"> 
                                    <!-- {{getItemStockLevel(item.itemID,store.id)}} -->
                                    {{ 
                                        itemsstocks.itemsStore.filter(itm => itm.itemID == item.itemID && itm.storeID == store.id).length
                                        ?
                                        itemsstocks.itemsStore.filter(itm => itm.itemID == item.itemID && itm.storeID == store.id)[0].qty
                                        :
                                        0
                                    }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </template>
                <template v-slot:card-footer>
                    <div class="w-full text-right">
                      <router-link :to="{ name: `inventory-management.index` }" class="btn-sm btn-danger text-xs rounded"><i class="fa fa-caret-left"></i> Back</router-link>
                    </div>
              </template>
            </tail-card>
        </template>
    </tail-base-layout>
</template>
